"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ButtonFooter = _interopRequireDefault(require("../ButtonFooter"));
var _ExpandButton = _interopRequireDefault(require("../ExpandButton"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactI18next = require("react-i18next");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DownloadModal = _ref => {
  let {
    active = false,
    children,
    data = [],
    fileName = 'Listado',
    headers = [],
    height = 'auto',
    loading = false,
    onFetchData = () => null,
    onToggle = () => null,
    separator = ';',
    width = 'auto'
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const containerProps = {
    height
  };
  const linkProps = {
    className: 'download-button',
    data,
    filename: "".concat(fileName, ".csv"),
    headers,
    separator,
    target: '_blank'
  };
  const modalProps = {
    active,
    width
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Modal.default, _objectSpread(_objectSpread({}, modalProps), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.Container, _objectSpread(_objectSpread({}, containerProps), {}, {
      children: [children, !loading && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ButtonFooter.default, {
        justify: "space-evenly",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Button, {
          onClick: onFetchData,
          children: (0, _isEmpty.default)(data) ? t('Generar listado') : t('Generar otro')
        }), !(0, _isEmpty.default)(data) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Separator, {
            children: "-"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.CSVLink, _objectSpread(_objectSpread({}, linkProps), {}, {
            children: t('Descargar')
          }))]
        })]
      }), loading && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
        active: true,
        size: 30,
        type: "dots"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonFooter.default, {
        margin: "20px 0px 0px 0px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandButton.default, {
          caption: t('Volver'),
          size: 100,
          onClick: onToggle
        })
      })]
    }))
  }));
};
DownloadModal.propTypes = {
  active: _propTypes.default.bool,
  children: _propTypes.default.any,
  data: _propTypes.default.array,
  fileName: _propTypes.default.string,
  headers: _propTypes.default.array,
  height: _propTypes.default.string,
  loading: _propTypes.default.bool,
  onFetchData: _propTypes.default.func,
  onToggle: _propTypes.default.func,
  separator: _propTypes.default.string,
  width: _propTypes.default.string
};
var _default = exports.default = DownloadModal;